import * as actionTypes from '../actions/actionTypes';

const initialState = {
    PersonData: [],
    PersonDetails: {},
    Persondata: {},
    ForgetPasswordEmail: {},
    // VenuData: false
    isLoading: false,
    personExistsConfirmation: null,
    guestPlayerConfirmation: null,  
};


const PersonsReducer = (state = initialState, action) => {

    switch (action.type) {
        case actionTypes.SET_LOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        case actionTypes.ADD_PERSONS:
            return {
                ...state,
            };

        case actionTypes.GET_PERSONS:
            return {
                ...state,
                PersonData: action.payload || [],
            };
        case actionTypes.Delete_PERSONS:
            return {
                ...state,
            }
        case actionTypes.GET_PERSONS_BY_ID:
            return {
                ...state,
                PersonDetails: action.payload || {},
            }
        case actionTypes.GET_PERSON:
            return {
                ...state,
                Persondata: action.payload || {}
            }
        case actionTypes.FORGET_PASSWORD:
            return {
                ...state,
                ForgetPasswordEmail: action.payload || {}
            }
        case actionTypes.CLEAR_PERSON:
            return {
                PersonData: [],
                PersonDetails: {},
                Persondata: {},
                ForgetPasswordEmail: {},
                // VenuData: false
                isLoading: false,
            }

        case 'SHOW_PERSON_EXISTS_CONFIRMATION':
        return {
            ...state,
            personExistsConfirmation: action.payload,
        };
        
        case 'CLEAR_PERSON_EXISTS_CONFIRMATION':
        return {
            ...state,
            personExistsConfirmation: null,
        };

        case 'SHOW_GUEST_PLAYER_CONFIRMATION':
//        console.log('🔵 REDUCER: SHOW_GUEST_PLAYER_CONFIRMATION');
//        console.log('Payload received:', action.payload);
        return {
        ...state,
        guestPlayerConfirmation: action.payload,
    };

    case 'CLEAR_GUEST_PLAYER_CONFIRMATION':
    return {
        ...state,
        guestPlayerConfirmation: null,
    };
        
        case 'SET_LOADING':
        return {
            ...state,
            isLoading: action.payload,
        };




        default:
            return state;
    }
}

export default PersonsReducer;
